import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Layout from '../../../componentsv2/Layout';
import Skeleton from '../../../componentsv2/Skeleton';

export default function BankingPageConversionsSkeleton() {
  return (
    <Layout>
      <Grid container rowSpacing={2}>
        <Grid item xs={8}>
          <Grid container rowSpacing={1}>
            <Grid item xs={12}>
              <Skeleton variant="rectangular" width="40%" height="36px" animation="wave" />
            </Grid>
            <Grid item xs={12}>
              <Skeleton variant="rectangular" width="60%" height="21px" animation="wave" />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={4} sx={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end' }}>
          <Box>
            <Skeleton variant="rectangular" width={150} height="40px" animation="wave" />
          </Box>
        </Grid>
        <Grid item xs={12} sx={{ display: 'flex', flex: 1 }}>
          <Box
            sx={{
              backgroundColor: '#fff',
              minHeight: '186px',
              borderRadius: '12px',
              padding: '1em 2em',
              width: '100%',
            }}
          >
            <Grid container rowSpacing={2}>
              {/* Filters Skeleton */}
              <Grid item xs={12}>
                <Grid container columnSpacing={2}>
                  <Grid item xs={5}>
                    <Skeleton variant="rectangular" width="100%" height="40px" animation="wave" />
                  </Grid>
                  <Grid item xs={3}>
                    <Skeleton variant="rectangular" width="100%" height="40px" animation="wave" />
                  </Grid>
                  <Grid item xs={3}>
                    <Skeleton variant="rectangular" width="100%" height="40px" animation="wave" />
                  </Grid>
                  <Grid item xs={1}>
                    <Skeleton variant="rectangular" width="100%" height="40px" animation="wave" />
                  </Grid>
                </Grid>
              </Grid>
              {/* Table Skeleton */}
              <Grid item xs={12}>
                <Skeleton variant="rectangular" width="100%" height={400} animation="wave" />
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </Layout>
  );
}
